exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".boxed-header{position:relative;padding:10px;margin-bottom:-1px;font-size:13px;line-height:26px;color:#68777d;background-color:#f2f9fc;border:1px solid #c9e6f2;border-radius:3px;border-bottom-right-radius:0;border-bottom-left-radius:0}.boxed-content{margin-bottom:10px;border:1px solid #ddd;border-top:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}[tooltip]:before{content:attr(tooltip);background:#585858;padding:2px 10px;margin-right:10px;border-radius:2px;color:#fff;font:500 12px;white-space:nowrap;position:absolute;bottom:20%;right:100%;visibility:hidden;opacity:0;-webkit-transition:.3s;transition:.3s}[tooltip]:hover:before{visibility:visible;opacity:1}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Tree.vue
 ** module id = 102
 ** module chunks = 0
 **/